import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CommentDataPayload,
  ICommentsDetailModel
} from '../../../pricing-simulator/components/comment-box-container/comment-box-container.model';
import fetchCommentsForRow from './api/drawer-api';

const getDataForComments = createAsyncThunk(
  'getDataForComments',
  async ({
    commentData,
    scenarioId
  }: {
    commentData: CommentDataPayload;
    scenarioId: number;
  }) => {
    const response = await fetchCommentsForRow(commentData, scenarioId);
    return response;
  }
);

interface IDrawerState {
  fetchingComments: boolean;
  isDisplayComments: boolean;
  /* model type: IProductComments */
  commentsData: ICommentsDetailModel;
  selectedRow: any;
}

const initialState: IDrawerState = {
  fetchingComments: false,
  isDisplayComments: false,
  commentsData: {
    details: {
      name: '',
      icon: ''
    },
    comments_data: []
  },
  selectedRow: {}
};

const DrawerManagerSlice = createSlice({
  name: 'Drawer-manager',
  initialState,
  reducers: {
    handleVisibilityOfComments(
      state,
      action: PayloadAction<{
        rowDetails: any;
      }>
    ) {
      state.isDisplayComments = true;
      state.selectedRow = action.payload.rowDetails;
    },
    handleCloseEventOfDrawer(state) {
      state.isDisplayComments = false;
      state.selectedRow = {};
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getDataForComments.pending, (state) => {
        state.fetchingComments = true;
      })
      .addCase(getDataForComments.fulfilled, (state, action) => {
        state.fetchingComments = false;
        state.commentsData = action.payload.data;
      })
      .addCase(getDataForComments.rejected, (state) => {
        state.fetchingComments = false;
        state.commentsData = {
          details: {
            name: '',
            icon: ''
          },
          comments_data: []
        };
      })
});

export const { handleVisibilityOfComments, handleCloseEventOfDrawer } =
  DrawerManagerSlice.actions;

export { getDataForComments };

export default DrawerManagerSlice;
